<template>
    
    <v-container>
        <div class="d-flex justify-space-between">
            <div>
                <v-tabs v-model="tab" grow class="tab-btn-style">
                    <v-tab class="c-tab" style="" v-if="permitObj.payment">Payment</v-tab>
                    <v-tab class="c-tab" v-if="permitObj.earning">Earning</v-tab>
                    <v-tab class="c-tab" v-if="permitObj.badDept">Bad Dept</v-tab>
                    <v-tab class="c-tab" v-if="permitObj.tutorEarning">Tutor Earning</v-tab>
                </v-tabs>
            </div>
        </div>


        <div class="nmt-1">
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <payment-table @created="handleCreate" :perms="permitObj"></payment-table>
                </v-tab-item>
                <v-tab-item>
                    <earning-table status="paid" v-bind:counter="rerender" :perms="permitObj"></earning-table>
                </v-tab-item>
                <v-tab-item>
                    <earning-table status="unpaid" v-bind:counter="rerender" :perms="permitObj"></earning-table>
                </v-tab-item>
                <v-tab-item>
                    <tutor-earning-table :perms="permitObj"></tutor-earning-table>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import PaymentTable from "../../../components/accounts/PaymentTable.vue";
import EarningTable from "../../../components/accounts/EarningTable.vue";
import BaddeptTable from "../../../components/accounts/BaddeptTable.vue";
import TutorEarningTable from "../../../components/accounts/TutorEarningTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions';

export default {
    name: "Accounts",
    components: {
        PaymentTable,
        EarningTable,
        BaddeptTable,
        TutorEarningTable,
        BreadCrumbs
    },
    data() {
        return {
            tab: null,
            rerender: 1,
            permitObj: {},
            breadItems: [{
                text: "Dashboard",
                disabled: false,
                href: "/",
                to: {
                    name: "DashBoard"
                }
            },
            {
                text: this.$route.meta.title,
                disabled: true,
                to: {
                    name: this.$route.name
                }
            }
            ]
        };
    },
    methods: {
        handleCreate() {
            this.rerender = this.rerender + 1;
        },
        getPermittedArray() {
            let links = this.$store?.getters?.permissions;
            let pathName = "Accounts";
            this.permitObj = getPermitObjects(links, pathName);
        }
    },
    created() {
        if (typeof this.$route.params != 'undefined' && this.$route.params != null) {
            this.tab = this.$route.params.tab;
        }
    },
    mounted() {
        this.getPermittedArray();
    },
};
</script>

<style lang="scss" scoped>
.nmt-1 {
    margin-top: -12px;
}

.c-tab {
    background: #f2f0f0;
    transition: background-color 0.2s;

    &.v-tab--active {
        background: white;
    }
}
</style>
